import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {editReservationRequestAttribute} from '../../../../utils/appConfigData';
import translate from '../../../../utils/translations';

export const EditReservationRequest = (props) => {
    const {attributes, avatar, role, sentText, text, translations} = props;
    const attributeMap = {};
    if (attributes) {
        attributes.forEach((attribute) => {
            attributeMap[attribute.key] = attribute.value;
        });
    }

    const getOldDates = () => {
        const oldEndDateFragment = attributeMap.hasOwnProperty(
            editReservationRequestAttribute.OLD_END_DATE
        )
            ? ` - ${attributeMap.oldEndDate}`
            : '';

        return (
            <div>
                <s>{`${attributeMap.oldBeginDate}${oldEndDateFragment}`}</s>
            </div>
        );
    };

    const getNewDates = () => {
        return (
            <div>
                <b>{`${attributeMap.newBeginDate} - ${attributeMap.newEndDate}`}</b>
            </div>
        );
    };

    const getOldGuests = () => {
        if (
            !attributeMap.hasOwnProperty(
                editReservationRequestAttribute.OLD_NUM_ADULTS
            )
        ) {
            return null;
        }

        const oldChidFragment = attributeMap.hasOwnProperty(
            editReservationRequestAttribute.OLD_NUM_CHILDREN
        )
            ? `, ${attributeMap.oldNumChildren}`
            : '';

        return (
            <div>
                <s>{`${attributeMap.oldNumAdults}${oldChidFragment}`}</s>
            </div>
        );
    };

    const getNewGuests = () => {
        const newChidFragment = attributeMap.hasOwnProperty(
            editReservationRequestAttribute.NEW_NUM_CHILDREN
        )
            ? `, ${attributeMap.newNumChildren}`
            : '';

        return (
            <div>
                <b>{`${attributeMap.newNumAdults}${newChidFragment}`}</b>
            </div>
        );
    };

    const getChangesRequested = () => {
        return (
            <Fragment>
                {attributeMap.hasOwnProperty(
                    editReservationRequestAttribute.NEW_BEGIN_DATE
                ) && (
                    <div
                        data-testid="requested-dates"
                        className="Message__editReservationRequestSection"
                    >
                        {getOldDates()}
                        {getNewDates()}
                    </div>
                )}
                {attributeMap.hasOwnProperty(
                    editReservationRequestAttribute.NEW_NUM_ADULTS
                ) && (
                    <div
                        data-testid="requested-guests"
                        className="Message__editReservationRequestSection"
                    >
                        {getOldGuests()}
                        {getNewGuests()}
                    </div>
                )}
            </Fragment>
        );
    };

    return (
        <div
            data-testid="edit-reservation-request-message"
            className={`Message Message--${role}`}
        >
            <div className="Message__avatar">
                <div
                    className="Message__avatar__image img-circle"
                    style={{backgroundImage: `url('${avatar}')`}}
                />
            </div>
            <div className="clearfix">
                <h4 className="Message__title">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'modifyBooking.travelerInbox.requestedChange.title'
                    )}
                </h4>
                <div className="Message__time">{sentText}</div>
            </div>
            {getChangesRequested()}
            {text && (
                <Fragment>
                    {(attributeMap.hasOwnProperty(
                        editReservationRequestAttribute.NEW_BEGIN_DATE
                    ) ||
                        attributeMap.hasOwnProperty(
                            editReservationRequestAttribute.NEW_NUM_ADULTS
                        )) && (
                        <h4
                            className="Message__editReservationRequestTextTitle"
                            data-testid="message-text-title"
                        >
                            {translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'modifyBooking.confirmation.yourMessageTitle'
                            )}
                        </h4>
                    )}
                    <div
                        data-testid="message-body"
                        className="Message__body Message__editReservationRequestSection"
                    >
                        {text}
                    </div>
                </Fragment>
            )}
        </div>
    );
};

EditReservationRequest.propTypes = {
    attributes: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            value: PropTypes.string,
        })
    ),
    avatar: PropTypes.string,
    role: PropTypes.string,
    sentText: PropTypes.string,
    text: PropTypes.string,
    translations: PropTypes.shape({}),
};
